import { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./CopyToClipboardButton.module.css";

import { Icon } from "gui/icon/icon";
import { IconButton } from "components/Button/IconButton";
import { Theme } from "components/Button/styles/buttonThemes";

interface Props {
  text: string;
  theme?: Theme;
  className?: string;
}

export default function CopyToClipboardButton({
  text,
  theme = "ghost",
  className,
}: Props) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) {
      return;
    }
    const id = setTimeout(() => setCopied(false), 1000);
    return () => clearTimeout(id);
  }, [copied]);

  if (copied) {
    return (
      <IconButton
        size="M"
        theme="ghost"
        className={cn(styles.checkFilled, className)}
        disabled
      >
        <Icon icon="check-filled" />
      </IconButton>
    );
  } else {
    return (
      <IconButton
        size="M"
        theme={theme}
        className={className}
        onClick={(event) => {
          event.preventDefault();
          navigator.clipboard.writeText(text).then(() => setCopied(true));
        }}
      >
        <Icon icon="copy" />
      </IconButton>
    );
  }
}
